/** Content bucket: every translation map is keyed by these three. */
export type Region = 'de' | 'ch' | 'en';

/** URL prefix. `at` is a site region of its own but reads the `de` copy. */
export type SiteRegion = Region | 'at';

export interface RegionConfig {
  code: SiteRegion;
  label: string;
  flag: string;
  locale: string;
  currency: string;
  countryName: string;
}

// Visual entries for the selector (can map multiple entries to the same Region)
export interface RegionSelectorEntry {
  code: SiteRegion;
  label: string;
  flag: string;
}

export const REGIONS: Record<Region, RegionConfig> = {
  de: {
    code: 'de',
    label: 'Deutschland',
    flag: '🇩🇪',
    locale: 'de-DE',
    currency: 'EUR',
    countryName: 'Deutschland',
  },
  ch: {
    code: 'ch',
    label: 'Schweiz',
    flag: '🇨🇭',
    locale: 'de-CH',
    currency: 'CHF',
    countryName: 'Schweiz',
  },
  en: {
    code: 'en',
    label: 'Europa',
    flag: '🇪🇺',
    locale: 'en',
    currency: 'EUR',
    countryName: 'International',
  },
};

export const DEFAULT_REGION: Region = 'de';

export const REGION_CODES = Object.keys(REGIONS) as Region[];

/** Config per URL prefix, including /at. */
export const SITE_REGIONS: Record<SiteRegion, RegionConfig> = {
  ...REGIONS,
  at: {
    code: 'at',
    label: 'Österreich',
    flag: '🇦🇹',
    locale: 'de-AT',
    currency: 'EUR',
    countryName: 'Österreich',
  },
};

export const SITE_REGION_CODES = ['de', 'ch', 'at', 'en'] as const satisfies readonly SiteRegion[];

/** Translation bucket for a URL prefix. */
export const CONTENT_REGION: Record<SiteRegion, Region> = { de: 'de', ch: 'ch', at: 'de', en: 'en' };

// Entries shown in the region selector dropdown
export const REGION_SELECTOR_ENTRIES: RegionSelectorEntry[] = [
  { code: 'de', label: 'Deutschland', flag: '🇩🇪' },
  { code: 'ch', label: 'Schweiz', flag: '🇨🇭' },
  { code: 'at', label: 'Österreich', flag: '🇦🇹' },
  { code: 'en', label: 'Europa', flag: '🇪🇺' },
];
